<template lang="pug">
  #challenge-builder
    WtTile.challenge-builder-define-form(ancestor vertical)
      WtTile(parent)
        WtTile(child child-class="")
          WtTitle.challenge-builder-title(h2) {{ challengeBuilderTitle }}

      WtTile(parent :col="12")
        WtTile(child child-class="" :col="12")
          ChallengeBuilderSteps(:active-step="activeStep" @activateCompletedStep="updateActiveStep($event)")
            WtTile(parent :col="12")
              WtTile(child :col="12")
                keepAlive
                  component(v-bind:is="activeStepComponent")
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { modeMixin } from "@/mixins/challengeBuilderMixin";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
import ChallengeBuilderSteps from "./ChallengeBuilderSteps";
import ChallengeBuilderType from "./ChallengeBuilderType";
import ChallengeBuilderDefine from "./ChallengeBuilderDefine";
import ChallengeBuilderAddParticipants from "./ChallengeBuilderAddParticipants";
import ChallengeBuilderReview from "./ChallengeBuilderReview";

export default {
  name: "ChallengeBuilder",

  components: {
    ChallengeBuilderReview,
    ChallengeBuilderType,
    ChallengeBuilderSteps,
    ChallengeBuilderDefine,
    ChallengeBuilderAddParticipants,
    WtButton,
    WtTile,
    WtTitle
  },

  mixins: [modeMixin],

  data() {
    return {
      stepComponents: []
    };
  },

  computed: {
    ...mapGetters("authMember", ["isAdmin"]),
    ...mapGetters("challengeBuilder", ["activeStep", "memberMode", "teamMode"]),

    activeStepComponent() {
      return this.stepComponents[this.activeStep - 1];
    },

    challengeBuilderTitle() {
      return "Challenge Builder";
    }
  },

  async mounted() {
    this.setAvailableComponents();

    // reset the form to ensure no data was saved from previous
    // challenge creation by setting formData to default values
    this.resetForm();

    // update state with initial challenge data
    this.updateFormData([
      { key: "programId", value: this.$auth.user().programId },
      { key: "isAdmin", value: this.isAdmin ? 1 : 0 }
    ]);
  },

  beforeDestroy() {
    this.updateActiveStep(1);
  },

  methods: {
    ...mapActions("challengeBuilder", [
      "updateFormData",
      "updateActiveStep",
      "resetForm",
      "setModes"
    ]),

    setAvailableComponents() {
      this.stepComponents = [
        "ChallengeBuilderType",
        "ChallengeBuilderDefine",
        "ChallengeBuilderAddParticipants",
        "ChallengeBuilderReview"
      ];
    }
  }
};
</script>

<style lang="sass" scoped></style>
